// Libraries
import { action, computed } from "mobx";

// Core
import { FieldType } from "Core/Utils/Utils";
import { ViewModelBase } from "Core/ViewModels/ViewModelBase";

// Custom
import { isNullOrUndefined } from "Custom/Utils/Utils";
import { PlygeneProductsModel } from "Custom/Models/Domain/ProductSelector/SubModels/GutterSystemSubModels/PlygeneProducts";
import { PlygeneMouldedViewModel } from "./PlygeneProductViewModels/PlygeneMouldedViewModel";
import { PlygeneStandardViewModel } from "./PlygeneProductViewModels/PlygeneStandardViewModel";

export class PlygeneProductsViewModel extends ViewModelBase<PlygeneProductsModel> {
    private plygeneMouldedViewModel: PlygeneMouldedViewModel;
    private plygeneStandardViewModel: PlygeneStandardViewModel;

    constructor(model: PlygeneProductsModel) {
        super(model);

        this.plygeneMouldedViewModel = new PlygeneMouldedViewModel(this.model.PlygeneMouldedModel);
        this.plygeneStandardViewModel = new PlygeneStandardViewModel(this.model.PlygeneStandardModel);
    }

    // #region Product Selection

    public get PlygeneMouldedViewModel(): PlygeneMouldedViewModel {
        return this.plygeneMouldedViewModel;
    }

    public get PlygeneStandardViewModel(): PlygeneStandardViewModel {
        return this.plygeneStandardViewModel;
    }

    @computed
    public get products(): any[] {
        return this.model.products;
    }

    @computed
    public get productSelection(): any {
        return this.model.productSelection;
    }

    @action
    public setProductSelection = (value: string): void => {
        this.model.productSelection = this.model.products.find((item: any) => {
            return item.value.toString() === value;
        });
    };

    // #endregion Product Selection

    // #region Moulded

    @computed
    public get canDisplayMoulded(): boolean {
        return !isNullOrUndefined(this.model.productSelection) && this.model.productSelection.value === "id_plygenemoulded";
    }

    // #endregion Moulded

    // #region Standard

    @computed
    public get canDisplayStandard(): boolean {
        return !isNullOrUndefined(this.model.productSelection) && this.model.productSelection.value === "id_plygenestandard";
    }

    // #endregion Standard

    // #region Viewmodel Boilerplate

    public afterUpdate: undefined;
    public beforeUpdate: undefined;

    public isFieldValid(fieldName: keyof FieldType<PlygeneProductsModel>): boolean {
        return true;
    }

    // #endregion Viewmodel Boilerplate
}
